function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSponsors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 19.455,
    viewBox: "0 0 19.453 19.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5079",
    d: "M230.422 0a5.453 5.453 0 1 0 5.472 5.472A5.472 5.472 0 0 0 230.422 0zm.571 7.942v.119a.57.57 0 0 1-1.14 0v-.055a2.065 2.065 0 0 1-.806-.343.57.57 0 1 1 .624-.954 1.01 1.01 0 0 0 .748.193.541.541 0 0 0 .541-.46.38.38 0 0 0-.286-.455 4.718 4.718 0 0 1-1.3-.629 1.428 1.428 0 0 1 .481-2.389v-.081a.57.57 0 0 1 1.14 0v.032a1.505 1.505 0 0 1 .662.381.57.57 0 0 1-.812.8.575.575 0 0 0-.587-.063.316.316 0 0 0-.2.25.223.223 0 0 0 .022.176 3.92 3.92 0 0 0 .979.451 1.6 1.6 0 0 1-.062 3.028z",
    transform: "translate(-216.44)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5080",
    d: "m6.455 325.358.866-.9L2.867 320l-1.919 1.881a3.2 3.2 0 0 0 0 4.492 3.194 3.194 0 0 0 4.492 0l.209-.209.965.965a.57.57 0 0 0 .806-.806z",
    transform: "translate(-.027 -307.841)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5081",
    d: "m98.292 191.856-6.692-6.688a.57.57 0 0 0-.944.223l-1.228 3.685 4.952 4.952 3.685-1.228a.57.57 0 0 0 .227-.944z",
    transform: "translate(-86.035 -177.972)",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsors);
export default __webpack_public_path__ + "static/media/sponsors.30691d96fbe0ed40a130077ccd9e91ed.svg";
export { ForwardRef as ReactComponent };